import React, { useState } from 'react';
import uploadFileToBlob, { isStorageConfigured } from './azure-storage-blob';
import { Grid, Button } from '@mui/material';

const storageConfigured = isStorageConfigured();


const App = ({ fieldName, setValue, disabled, defaultValues, unload, setUnload }) => {

    // all blobs in container
    const [blobList, setBlobList] = useState([]);

    // current file to upload into container
    const [fileSelected, setFileSelected] = useState(null);
    const [itemString, setItemString] = useState(null);

    // UI/form management
    const [uploading, setUploading] = useState(false);
    const [inputKey, setInputKey] = useState(Math.random().toString(36));

    const onFileChange = (event) => {
        // capture file into state
        setFileSelected(event.target.files[0]);
    };

    const onFileUpload = async () => {
        // prepare UI
        setUploading(true);
        // *** UPLOAD TO AZURE STORAGE ***
        const blobsInContainer = await uploadFileToBlob(fileSelected);
        const string = `https://thoxfileuploads.blob.core.windows.net/thox/${fileSelected.name}`
        setValue(fieldName, string)
        // prepare UI for results
        setBlobList(blobsInContainer);
        setItemString(string);
        // reset state/form
        setFileSelected(null);
        setUploading(false);
        setInputKey(Math.random().toString(36));
    };

    // display form
    const DisplayForm = () => (
        <Grid container>
            <Grid item xs={6}>
                <Button
                    variant={fileSelected ? "outlined" : "contained"}
                    component="label"
                    disabled={disabled}
                >
                    Browse
                    <input
                        type="file"
                        hidden
                        disabled={disabled}
                        name={fieldName}
                        onChange={onFileChange}
                        key={inputKey || ''}
                    />
                </Button>
            </Grid>
            <Grid item xs={6}>
                <Button variant={fileSelected ? "contained" : "outlined"} disabled={disabled || !fileSelected} type="submit" onClick={onFileUpload}>
                    Upload!
                </Button>
            </Grid>
        </Grid>
    )

    // display file name and image
    const DisplayImageFromContainer = () => {
        const imageURL = blobList.find(item => itemString === item)
        if (imageURL.slice(-3) === 'pdf') {
            return <div>
                New Upload
                <br />
                <embed src={imageURL} width="375" height="375" type="application/pdf" />
            </div>
        } else {
            return (
                <div>
                    New Upload
                    <br />
                    <img src={imageURL} alt={imageURL} height="200" />
                </div>
            );
        }
    };
    const RenderCurrentImage = (imageURL) => {
        if (imageURL.slice(-3) === 'pdf') {
            return <embed src={imageURL} width="375" height="375" type="application/pdf" />
        } else {
            return <img src={imageURL} alt={imageURL} height="200" />
        }
    };

    return (
        <div>
            {defaultValues[fieldName] && <div>
                Current
                <br />
                {RenderCurrentImage(defaultValues[fieldName])}
            </div>}
            {storageConfigured && !uploading && DisplayForm()}
            {storageConfigured && uploading && <div>Uploading</div>}
            {storageConfigured && blobList.length > 0 && itemString && DisplayImageFromContainer()}
            {/* {storageConfigured && defaultValues[fieldName] && DisplayImage(defaultValues[fieldName])} */}
        </div>
    );
};

export default App;
